import { auth } from '@webclient/lib/agent';

import useQueryParams from '@webclient/hooks/useQueryParams';

import { UserOwnerType } from '@webclient/shared-types/agent';

import { useMutation } from '@tanstack/react-query';

type Props = {
  onSuccess?: (data: unknown, context: unknown) => Promise<unknown> | unknown;
  onError?: (error: Error, context: unknown) => Promise<unknown> | unknown;
};

export default function useMutateMe({ onSuccess, onError }: Props) {
  const { getQueryParamByKey } = useQueryParams();
  const contactTokenQueryParam = getQueryParamByKey<string | null>(
    'contact_token',
  );

  return useMutation({
    mutationKey: ['me'],
    mutationFn: async (data: Partial<Omit<UserOwnerType, 'id'>>) =>
      await auth.updateMe(data, contactTokenQueryParam),
    onSuccess,
    onError,
  });
}
